import s from "../defaultPicker.module.css";
import {iconInfoSectionArrow} from "../../../../../../../assets";
import Item from "./Item";
import {h} from "preact";
import {useAppContext} from "../../../../../../../contexts";
import {useAttendanceRegion} from "./useAttendanceRegion";

const AttendanceRegion = (props) => {
    // Destructured props
    const {
        region,
        hasSubmitted,
        errors,
        errorMessage,
        handleChange,
        selectedValue,
        openedRegionID,
        handleOpen
    } = props;

    // Component logic data
    const componentProps = useAttendanceRegion();

    // Destructured component logic data
    const {
        // isOpen,
        // handleOpen
    } = componentProps;

    // Accessibility feature data
    const {highContrast} = useAppContext();

    // Checks whether the current region is checked or not
    const isOpen = openedRegionID === region.id;

    return (
        <div className={s.root}>
            <button
                type="button"
                className={`
                    ${s.buttonStyling} 
                    ${highContrast ? "text-white" : "text-black"}
                    ${isOpen ? (
                        highContrast ? "!text-[#fecc31]" : "!text-sabin-red-default"
                    ) : ""}
                `}
                data-testid={`product-page-units-button`}
                onClick={() => handleOpen(region.id)}
            >
                <span>
                    {region.name}
                </span>
                <img
                    src={iconInfoSectionArrow}
                    className={`
                        ${s.arrowIcon} 
                        ${(isOpen ? "rotate-180" : "")} 
                        ${highContrast ? "highImage" : ""}
                    `}
                    alt="Arrow icon"
                />
            </button>
            <span
                className={`
                    uppercase text-sabin-red-default text-[13px] font-bold
                    ${(hasSubmitted && errors) ? '' : 'hidden'}
                    ${highContrast ? "highLabelSecond" : ""}
                `}
            >
                {errorMessage}
            </span>
            <div className={`${s.openDropdownContainer} v3-collapsible-accordion ${(!isOpen ? " hidden" : "")}`}>
                <ul className={s.ul}>
                    {region.items.length < 1 ? null : region.items.map(item => {
                        return (
                            <Item
                                key={item.id}
                                item={item}
                                handleChange={handleChange}
                                selectedValue={selectedValue}
                            />
                        )
                    })}
                </ul>
            </div>
        </div>
    )
}

export default AttendanceRegion;
